import { withHighlight } from "./Highlight";

/**
 * Eyebrow + heading + intro. `as` lets a page use <h1> once; every other section uses the default <h2>.
 * `highlight` is an exact phrase inside `title` that gets the orange highlighter pen.
 * The eyebrow is quiet small caps text, not a coloured pill. `onBrand` is kept for older call sites and now only
 * means "sits on a light blue panel", so the text stays dark.
 */
export function SectionHeading({ id, eyebrow, title, highlight, intro, as: Tag = "h2", className = "", titleClassName = "" }) {
  return (
    <div className={`max-w-3xl ${className}`}>
      {eyebrow ? <p className="mb-3 text-xs font-bold uppercase tracking-widest text-brand-600">{eyebrow}</p> : null}
      <Tag
        id={id}
        className={`font-heading text-3xl font-bold leading-tight sm:text-4xl lg:text-5xl ${titleClassName}`}
      >
        {withHighlight(title, highlight)}
      </Tag>
      {intro ? <p className="mt-3 max-w-[56ch] text-base text-ink/70 sm:text-lg">{intro}</p> : null}
    </div>
  );
}
